import {
  ADDITIONAL_TRADING_PREFERENCES,
  TRADING_REQUEST_TYPES,
} from "@tastyworks/shared-utils/misc/constants"
import { SchemaDeSer, SchemaDeSerBuilder } from "./deser"

// Mirrors the backend AccountOpeningApplicationEnablement::Types, Futures does
// not exist as a TRADING_REQUEST_TYPE and would break CAM if it were added
export const EnablementTypes = {
  CRYPTOCURRENCY_TRADING: TRADING_REQUEST_TYPES.CRYPTOCURRENCY_TRADING,
  FUTURES_TRADING: ADDITIONAL_TRADING_PREFERENCES.FUTURES_TRADING,
} as const

export type EnablementTypes =
  (typeof EnablementTypes)[keyof typeof EnablementTypes]

export class Enablement {
  enablementType: EnablementTypes | null = null
}
export class Enablements {
  enablements: Enablement[] = []
}

const ENABLEMENT_DESER: SchemaDeSer<Enablement> = new SchemaDeSerBuilder(
  Enablement
)
  .ofString("enablementType")
  .toDeSer()

export const ENABLEMENTS_DESER: SchemaDeSer<Enablements> =
  new SchemaDeSerBuilder(Enablements)
    .ofArray("enablements", ENABLEMENT_DESER, Enablement)
    .toDeSer()
